import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getOrganizationIdFromLocation = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.organizationId || null);

export default getOrganizationIdFromLocation;
